
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDTzcw24FWqbFA6nxcyJDJeLhqY0v7IGlzcn1pLV1QBAMeta } from "/var/www/html/frontend/app/pages/index.vue?macro=true";
import { default as _91id_93WxN03tjtd9B1h7pR2joy8sxGir6MpLwc_v6CdsyHAP8Meta } from "/var/www/html/frontend/app/pages/form/[id].vue?macro=true";
import { default as indexUoX50W8EMIELHZUL_YcrOVZ6AjmoOsQ748Fx5miGSqQMeta } from "/var/www/html/frontend/app/pages/event/index.vue?macro=true";
import { default as indexXSAAKGM4orOVHSabezHAEoE0x083ZUI3EkH3iib4hBQMeta } from "/var/www/html/frontend/app/pages/search/index.vue?macro=true";
import { default as index6SxycynW2Frp_FoBoz9lgOiFV6Xv5YwNFpo9to7coVkMeta } from "/var/www/html/frontend/app/pages/[...slug]/index.vue?macro=true";
import { default as indexGLUvT1Le_6saty7EgA9M11srgDDJt5UIw3OmCsvRreQMeta } from "/var/www/html/frontend/app/pages/node/[nid]/index.vue?macro=true";
import { default as indexxbHK9kmo4E7MfyUnAcOyP77BTNC8DN3B_bt_KluqWyEMeta } from "/var/www/html/frontend/app/pages/press-release/index.vue?macro=true";
import { default as indexv2vOPBJLXO6UnM2fkXg3B0bjHUOqJ3ZgLo_uNMerhyoMeta } from "/var/www/html/frontend/app/pages/event/[...slug]/index.vue?macro=true";
import { default as _91id_93jCddYEv9ARv9z0prBryIywCTFpoHpfqedmQUVfQVu00Meta } from "/var/www/html/frontend/app/pages/form/confirmation/[id].vue?macro=true";
import { default as indexGkfv_GJRIHKnjIDMEemLvIvWhBTU2JIGvz1m26DSDB0Meta } from "/var/www/html/frontend/app/pages/contact/[...slug]/index.vue?macro=true";
import { default as index_qvIMdlumIsSv6pgXUqq_ck1Db_mADMk4yceYwm8LQsMeta } from "/var/www/html/frontend/app/pages/integration-programs/index.vue?macro=true";
import { default as _91uuid_93m1BkWoEFU6HfdT_FnFWGkPea3vLtUkenQkMfpZ4mEiAMeta } from "/var/www/html/frontend/app/pages/blokkli/library-item/[uuid].vue?macro=true";
import { default as indexnr1L0Kny1rkHkKpxP3krXpfD8lq_YBf_6SAUqrT_4CcMeta } from "/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue?macro=true";
import { default as FilterButtongkwPbdwVPd1ooCVx7lbWFRzdMfVdVro2tBduTr7rmPIMeta } from "/var/www/html/frontend/app/pages/integration-programs/FilterButton.vue?macro=true";
import { default as indexJtTLM_mwM_YRNKqq0m_bBER9hjOMkpiLfPP6mS4B5Z0Meta } from "/var/www/html/frontend/app/pages/integration-programs/[...slug]/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/:langPrefix(de|fr|en)",
    meta: { ...(indexDTzcw24FWqbFA6nxcyJDJeLhqY0v7IGlzcn1pLV1QBAMeta || {}), ...{"originalName":"home"} },
    component: () => import("/var/www/html/frontend/app/pages/index.vue")
  },
  {
    name: "webform-route",
    path: "/:langPrefix(de|fr|en)/form/:id()",
    meta: { ...(_91id_93WxN03tjtd9B1h7pR2joy8sxGir6MpLwc_v6CdsyHAP8Meta || {}), ...{"originalName":"webform-route"} },
    component: () => import("/var/www/html/frontend/app/pages/form/[id].vue")
  },
  {
    name: "events",
    path: "/:langPrefix(de|fr|en)/die-aoz/wissensvermittlung/veranstaltungen",
    meta: {"drupalFrontendRoute":true,"originalName":"events"},
    component: () => import("/var/www/html/frontend/app/pages/event/index.vue")
  },
  {
    name: "search___de",
    path: "/de/suche",
    meta: {"drupalFrontendRoute":true,"originalName":"search"},
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "search___fr",
    path: "/fr/chercher",
    meta: {"drupalFrontendRoute":true,"originalName":"search"},
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: {"drupalFrontendRoute":true,"originalName":"search"},
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "drupal-route",
    path: "/:slug(.*)*",
    component: () => import("/var/www/html/frontend/app/pages/[...slug]/index.vue")
  },
  {
    name: "node-canonical",
    path: "/:langPrefix(de|fr|en)/node/:nid()",
    meta: {"originalName":"node-canonical"},
    component: () => import("/var/www/html/frontend/app/pages/node/[nid]/index.vue")
  },
  {
    name: "press-releases___de",
    path: "/de/medienmitteilung",
    meta: {"drupalFrontendRoute":true,"originalName":"press-releases"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/index.vue")
  },
  {
    name: "press-releases___fr",
    path: "/fr/communiques-de-presse",
    meta: {"drupalFrontendRoute":true,"originalName":"press-releases"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/index.vue")
  },
  {
    name: "press-releases___en",
    path: "/en/press-release",
    meta: {"drupalFrontendRoute":true,"originalName":"press-releases"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/index.vue")
  },
  {
    name: "event-detail",
    path: "/:langPrefix(de|fr|en)/die-aoz/wissensvermittlung/veranstaltungen/:slug(.*)*",
    meta: {"drupalFrontendRoute":true,"originalName":"event-detail"},
    component: () => import("/var/www/html/frontend/app/pages/event/[...slug]/index.vue")
  },
  {
    name: "webform-confirmation",
    path: "/:langPrefix(de|fr|en)/form/confirmation/:id()",
    meta: { ...(_91id_93jCddYEv9ARv9z0prBryIywCTFpoHpfqedmQUVfQVu00Meta || {}), ...{"originalName":"webform-confirmation"} },
    component: () => import("/var/www/html/frontend/app/pages/form/confirmation/[id].vue")
  },
  {
    name: "contact-slug___de",
    path: "/de/kontakt/:slug(.*)*",
    meta: {"originalName":"contact-slug"},
    component: () => import("/var/www/html/frontend/app/pages/contact/[...slug]/index.vue")
  },
  {
    name: "contact-slug___fr",
    path: "/fr/contact/:slug(.*)*",
    meta: {"originalName":"contact-slug"},
    component: () => import("/var/www/html/frontend/app/pages/contact/[...slug]/index.vue")
  },
  {
    name: "contact-slug___en",
    path: "/en/contact/:slug(.*)*",
    meta: {"originalName":"contact-slug"},
    component: () => import("/var/www/html/frontend/app/pages/contact/[...slug]/index.vue")
  },
  {
    name: "integration-programs___de",
    path: "/de/kurse-und-angebote",
    meta: {"drupalFrontendRoute":true,"originalName":"integration-programs"},
    component: () => import("/var/www/html/frontend/app/pages/integration-programs/index.vue")
  },
  {
    name: "integration-programs___fr",
    path: "/fr/programmes-dintegration",
    meta: {"drupalFrontendRoute":true,"originalName":"integration-programs"},
    component: () => import("/var/www/html/frontend/app/pages/integration-programs/index.vue")
  },
  {
    name: "integration-programs___en",
    path: "/en/integration-programs",
    meta: {"drupalFrontendRoute":true,"originalName":"integration-programs"},
    component: () => import("/var/www/html/frontend/app/pages/integration-programs/index.vue")
  },
  {
    name: "blokkli-library-item-uuid",
    path: "/:langPrefix(de|fr|en)/blokkli/library-item/:uuid()",
    meta: { ...(_91uuid_93m1BkWoEFU6HfdT_FnFWGkPea3vLtUkenQkMfpZ4mEiAMeta || {}), ...{"originalName":"blokkli-library-item-uuid"} },
    component: () => import("/var/www/html/frontend/app/pages/blokkli/library-item/[uuid].vue")
  },
  {
    name: "press-release-detail___de",
    path: "/de/medienmitteilung/:slug(.*)*",
    meta: {"originalName":"press-release-detail"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "press-release-detail___fr",
    path: "/fr/communiques-de-presse/:slug(.*)*",
    meta: {"originalName":"press-release-detail"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "press-release-detail___en",
    path: "/en/press-release/:slug(.*)*",
    meta: {"originalName":"press-release-detail"},
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "integration-programs-FilterButton",
    path: "/:langPrefix(de|fr|en)/integration-programs/FilterButton",
    meta: {"originalName":"integration-programs-FilterButton"},
    component: () => import("/var/www/html/frontend/app/pages/integration-programs/FilterButton.vue")
  },
  {
    name: "integration-programs-detail",
    path: "/:langPrefix(de|fr|en)/kurse-und-angebote/:slug(.*)*",
    meta: {"originalName":"integration-programs-detail"},
    component: () => import("/var/www/html/frontend/app/pages/integration-programs/[...slug]/index.vue")
  }
]